import styled from "styled-components";
import PropTypes from "prop-types";

import { bold as boldStyles } from "./fontStyles";
import { default as fonts } from "./fonts";

const Label = styled.label`
    ${({ size }) => fonts.typeScale[size]}
    ${({ bold }) => (bold ? boldStyles : null)}
`;

Label.propTypes = {
    size: PropTypes.number.isRequired,
    bold: PropTypes.bool
};

export { Label };
